import React, { useEffect, useState, useMemo } from 'react';
import get from 'lodash.get';
import {
  Box,
  Collapse,
  List,
  ListItemText,
  ListItemButton,
} from '@mui/material';
// import { matchRoutes } from "react-router-config";
import { useTheme } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';

import { useShop } from 'providers/Shop';

import Drawer from 'components/Drawer';
import { CloseButton } from 'components/IconButtons';

import { baseRoute } from 'config/const';
import { MainRoutes } from 'routes';
import { matchRoutes } from 'utils/method';
import { handleMenu } from './method';
import { floatLeft } from 'styles';
import { ListStyle } from './style';

function ExpandableItems({
  open,
  item,
  isExpand = false,
  showIcon = false,
  goPath,
}) {
  const { name, key, children } = item;
  const isOpen = isExpand ? true : open === key;
  return (
    <>
      <ListItemButton>
        <ListItemText
          primaryTypographyProps={{ variant: 'body2' }}
          color="menu.primary"
          primary={name}
        />
        {showIcon ? isOpen ? <ExpandLess /> : <ExpandMore /> : null}
      </ListItemButton>
      <Collapse in={isOpen} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {children.map((c) => (
            <ListItemButton
              key={c.key}
              onClick={() => goPath(c.path)}
              sx={{ pl: 3 }}
            >
              <ListItemText
                primaryTypographyProps={{
                  color: 'menu.secondary',
                }}
                primary={c.name}
              />
            </ListItemButton>
          ))}
        </List>
      </Collapse>
    </>
  );
}

function RoutesMenu({ isMenuOpen, toggleDrawer }) {
  const shop = useShop();
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState();
  const navigate = useNavigate();
  const theme = useTheme();
  const displayRoutes = MainRoutes().filter(({ displayMenu }) => displayMenu);
  const _routes = useMemo(
    () => handleMenu({ routes: displayRoutes, shop }),
    [shop],
  );

  const goPath = (path) => {
    toggleDrawer();
    navigate(`${baseRoute}${path}`);
  };

  useEffect(() => {
    const selected = matchRoutes(_routes, window.location.pathname);
    setSelected(get(selected, '[0].route.path'));
  }, [window.location.pathname]);

  const handleSelect = (key, path) => {
    setOpen(key);
    setSelected(path);
  };
  const getSelectedClassName = (path) =>
    selected === path ? 'selected' : 'unselected';

  return (
    <Drawer
      variant="permanent"
      width={200}
      sx={{ maxWidth: '100vw' }}
      anchor={'left'}
      isOpen={isMenuOpen}
      toggleDrawer={toggleDrawer}
    >
      <Box sx={floatLeft} p={1}>
        <CloseButton onClose={toggleDrawer} />
      </Box>
      <Box pl={3} pr={3}>
        {_routes.map(({ name, key, path, children, isExpand }) => (
          <List
            className={getSelectedClassName(path)}
            key={key}
            sx={ListStyle(theme)}
            onClick={() => handleSelect(key, path)}
          >
            {children ? (
              <ExpandableItems
                open={open}
                item={{ name, key, children }}
                isExpand={isExpand}
                goPath={goPath}
              />
            ) : (
              <ListItemButton onClick={() => goPath(path)}>
                <ListItemText
                  primaryTypographyProps={{ variant: 'body2' }}
                  color="menu.primary"
                  primary={name}
                />
              </ListItemButton>
            )}
          </List>
        ))}
      </Box>
    </Drawer>
  );
}

export default RoutesMenu;
